module.exports = __webpack_public_path__ + "img/Campbellton_KeyFindings.c956d320.png";